import { MediaItem } from '@repo/roche-xx-shared';
import React from 'react';
import { DataSearchView } from '../../search/data-search';
import { RocheEventListItem } from '../../search/data-search/list-items/event-list-item';
import { fetchEventsList, fetchEventsTabs } from '../../search/data-search/queries';
import { EventItem } from '../../search/data-search/types';
import { SearchTrackingType } from '../../search/tracking';
import { Props } from './types';

export const RocheMediaEventsList = ({ slot }: Props): JSX.Element => {
  return (
    <DataSearchView<MediaItem | EventItem>
      slot={slot}
      searchTrackingType={SearchTrackingType.MEDIA_EVENTS}
      tabName='year'
      pageName='page'
      fetchTabs={fetchEventsTabs}
      fetchList={fetchEventsList}
      itemRenderer={(item, index, trackingData) => (
        <RocheEventListItem key={`${item['Start Date']}-${index}`} item={item} trackingData={trackingData} />
      )}
    />
  );
};
